import { Location } from '@angular/common';
import { Component, OnDestroy, OnInit, EventEmitter, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { StaffLoginService } from 'src/app/services/staff-login/staff-login.service';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
  @Output("loginPage") loginPage: EventEmitter<any> = new EventEmitter();

  passConfirmationForm: FormGroup;
  reset_mobile_email: FormControl = new FormControl('', Validators.required);
  otp_ctrl: FormControl = new FormControl('', Validators.required);

  selectedIndex: any = 0;

  countdown: number = -1;

  verify_otp_error_msg: string = '';
  verify_otp_success_msg: string = '';
  verify_otp_response: any;
  otp_response: any;
  pass_update_response: any;
  otp_error_msg: string = '';
  update_pass_error_msg: string = '';

  is_passReset: boolean = false;
  show_otp_filed: boolean = false;
  is_verifyingOtp: boolean = false;
  is_passUpdating: boolean = false;
  is_passSucUpdated: boolean = false;
  showValidationTxt: boolean = false;
  is_reset_password: boolean = false;
  is_old_pass_type_password: boolean = false;
  is_new_pass_type_password: boolean = false;
  is_from_verify_account: boolean = false;
  submitted: boolean = false;
  policyType: 'standard' | 'strong' = 'standard';

  login_response: any;

  private _onDestroy = new Subject<void>();

  constructor(
    private formBuilder: FormBuilder,
    private staffLoginService: StaffLoginService,
    private location: Location,
    public router: Router,
    private authService: AuthService
  ) {
    const loginResponseData = this.authService.getLoginResponseData();
    if (loginResponseData) {
      this.login_response = loginResponseData;
      this.is_from_verify_account = true;
      this.selectedIndex = 2;
      this.policyType = this.login_response?.data?.fnPasswordType || 'standard';
    }
  }

  ngOnInit(): void {
    this.passConfirmationForm = this.formBuilder.group({
      new_password: ['', [this.gatedPasswordValidator()]],
      confirm_password: ['', [this.gatedConfirmPasswordValidator()]]
    });

    this.passConfirmationForm.valueChanges.subscribe(value => {
      this.update_pass_error_msg = '';
    });

    // Clear field-level error on the next edit after a failed submit.
    this.passConfirmationForm.get('new_password').valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        if (this.submitted) {
          this.submitted = false;
          this.passConfirmationForm.get('new_password').updateValueAndValidity({ emitEvent: false });
          this.passConfirmationForm.get('confirm_password').updateValueAndValidity({ emitEvent: false });
        }
      });

    this.passConfirmationForm.get('confirm_password').valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        if (this.submitted) {
          this.submitted = false;
          this.passConfirmationForm.get('new_password').updateValueAndValidity({ emitEvent: false });
          this.passConfirmationForm.get('confirm_password').updateValueAndValidity({ emitEvent: false });
        }
      });

    this.reset_mobile_email.valueChanges.subscribe(value => {
      this.verify_otp_error_msg = '';
    });

    this.otp_ctrl.valueChanges.subscribe(value => {
      this.otp_error_msg = '';
    });
  }

  getLoginDetails() {
    const credentials: any = {
      username: this.reset_mobile_email.value ? this.reset_mobile_email?.value?.trim() : ''
    };

    this.staffLoginService.login(credentials).pipe(takeUntil(this._onDestroy)).subscribe((res: any) => {

      if (res?.data?.existing_user == '1') {
        this.forgotPassword();
      } else {
        this.verify_otp_error_msg = res?.message;
        this.selectedIndex = 0;
        this.is_passReset = false;
      }
    }, error => {
      console.log('error', error);
      this.verify_otp_error_msg = `Error! Please try again or contact <a href="mailto:support@truein.com">support@truein.com<a> for help.`;
    });
  }

  forgotPassword() {
    this.is_passReset = true;
    this.verify_otp_error_msg = '';
    const credentials: any = {
      username: this.reset_mobile_email.value ? this.reset_mobile_email?.value?.trim() : ''
    };

    this.staffLoginService.forgotPassword(credentials).pipe(takeUntil(this._onDestroy)).subscribe(res => {
      this.verify_otp_response = res;
    }, error => {
      console.log('error', error);
      this.verify_otp_error_msg = `Error! Please try again or contact <a href="mailto:support@truein.com">support@truein.com<a> for help.`;
      this.selectedIndex = 0;
      this.is_passReset = false;
    }, () => {
      if(this.verify_otp_response.code == '1') {
        this.policyType = this.verify_otp_response?.data?.fnPasswordType || this.policyType || 'standard';
        this.startCountdown();
        this.is_passReset = true;
        this.show_otp_filed = true;
        this.verify_otp_success_msg = this.verify_otp_response?.message;
        this.selectedIndex = 1;
      } else if(this.verify_otp_response.code == '0') {
        this.verify_otp_error_msg = this.verify_otp_response?.message;
        this.is_passReset = false;
      } else {
        this.verify_otp_error_msg = `Error! Please try again or contact <a href="mailto:support@truein.com">support@truein.com<a> for help.`;
        this.is_passReset = false;
      }
    })
  }

  checkUppercase(control) {
    return control.value && control.value.match(/[A-Z]/) ? null : { uppercase: true }
  }

  checkNumber(control) {
    return control.value && control.value.match(/[0-9]/) ? null : { number: true }
  }

  newPasswordHasUppercase(): boolean {
    return /[A-Z]/.test(this.passConfirmationForm?.get('new_password')?.value ?? '');
  }

  newPasswordHasNumber(): boolean {
    return /[0-9]/.test(this.passConfirmationForm?.get('new_password')?.value ?? '');
  }

  newPasswordHasLowercase(): boolean {
    return /[a-z]/.test(this.passConfirmationForm?.get('new_password')?.value ?? '');
  }

  newPasswordHasSpecialChar(): boolean {
    return /[^A-Za-z0-9]/.test(this.passConfirmationForm?.get('new_password')?.value ?? '');
  }

  private gatedPasswordValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!this.submitted) return null;
      const value: string = control.value ?? '';
      if (!value) return { required: true };
      const errors: ValidationErrors = {};
      if (value.length < 8) errors['minlength'] = { requiredLength: 8, actualLength: value.length };
      if (value.length > 20) errors['maxlength'] = { requiredLength: 20, actualLength: value.length };
      if (!value.match(/[A-Z]/)) errors['uppercase'] = true;
      if (!value.match(/[0-9]/)) errors['number'] = true;
      if (this.policyType === 'strong') {
        if (!value.match(/[a-z]/)) errors['lowercase'] = true;
        if (!value.match(/[^A-Za-z0-9]/)) errors['specialChar'] = true;
      }
      return Object.keys(errors).length === 0 ? null : errors;
    };
  }

  private gatedConfirmPasswordValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!this.submitted) return null;
      const value: string = control.value ?? '';
      if (!value) return { required: true };
      const newPassword = this.passConfirmationForm?.get('new_password')?.value ?? '';
      if (value !== newPassword) return { mismatch: true };
      return null;
    };
  }

  verifyOtp() {

    if(this.otp_ctrl.invalid) {
      this.otp_ctrl.markAsTouched()
    } else {
      this.is_verifyingOtp = true;
      let credentials: any = {
        otp: this.otp_ctrl.value,
        uid: this.verify_otp_response?.data.uid,
        token: this.verify_otp_response?.data?.token
      };

      this.staffLoginService.verifyOtp(credentials).pipe(takeUntil(this._onDestroy)).subscribe(res => {
        this.otp_response = res;
      }, error => {
        console.log('error', error);
        this.is_verifyingOtp = false;
      }, () => {
        this.is_verifyingOtp = false;
        if(this.otp_response.code == '1') {
          this.selectedIndex = 2;
        } else if(this.otp_response.code == '0') {
          this.otp_error_msg = this.otp_response.message;
          this.selectedIndex = 1;
        } else {
          this.otp_error_msg = `Error! Please try again or contact <a href="mailto:support@truein.com">support@truein.com<a> for help.`;
          this.selectedIndex = 1;
        };
      });
    }
  }

  validateRstPassField() {
    if (this.reset_mobile_email.invalid) {
      this.reset_mobile_email.markAsTouched({ onlySelf: true });
    }
  }

  startCountdown() {
    this.countdown = 60;
    let timer = setInterval(() => {
      this.countdown--;
      if(this.countdown === -1) {
        clearInterval(timer);
        this.is_passReset = false;
      }
    }, 1000);
  }

  getFieldErrorMsg(pass_field: string) {
    const errs = this.passConfirmationForm.controls[pass_field].errors;
    const parts: string[] = [];
    if (errs?.minlength) parts.push('8 characters');
    if (errs?.uppercase) parts.push('one uppercase letter');
    if (errs?.number) parts.push('one number');
    if (errs?.lowercase) parts.push('one lowercase letter');
    if (errs?.specialChar) parts.push('one special character');
    if (parts.length === 0) return '';
    if (parts.length === 1) return 'Password must contain at least ' + parts[0];
    return 'Password must contain at least ' + parts.slice(0, -1).join(', ') + ', and ' + parts[parts.length - 1];
  }

  changePassword() {
    this.submitted = true;
    this.passConfirmationForm.get('new_password').updateValueAndValidity({ emitEvent: false });
    this.passConfirmationForm.get('confirm_password').updateValueAndValidity({ emitEvent: false });

    if(this.passConfirmationForm.invalid) {
      this.passConfirmationForm.markAllAsTouched();
      if(this.passConfirmationForm.get('new_password').value && this.passConfirmationForm.get('confirm_password').value) {
        this.showValidationTxt = true;
      }
    } else if((this.passConfirmationForm.get('new_password').value !== this.passConfirmationForm.get('confirm_password').value) && this.selectedIndex == 2) {
      this.update_pass_error_msg = 'Passwords do not match';
    } else {
      this.is_passUpdating = true;
      this.is_passSucUpdated = false;

      const credentials: any = {
        password: this.passConfirmationForm.get('new_password').value,
        uid: this.is_from_verify_account ? this.login_response?.uid : this.otp_response?.data?.uid,
        token: this.is_from_verify_account ? this.login_response?.token : this.otp_response?.data?.token
      };

      let api_call: any;
      if (this.is_from_verify_account) {
        credentials.mobile = this.login_response?.data?.mobile;
        credentials.office_email = this.login_response?.data?.office_email;
        credentials.client_site_id = String(this.login_response?.data?.client_site_id);
        credentials.company_name = this.login_response?.data?.company;
        credentials.name = this.login_response?.data?.name;
        credentials.country_code = this.login_response?.data?.country_code;

        api_call = this.staffLoginService.signUp(credentials);
      } else {
        api_call = this.staffLoginService.changePassword(credentials);
      };

      api_call.pipe(takeUntil(this._onDestroy)).subscribe((res) => {
        this.pass_update_response = res;
      }, error => {
        console.log('error', error)
        this.is_passUpdating = false;
        this.is_passSucUpdated = false;
      }, () => {
        if(this.pass_update_response.code == '1') {
          this.update_pass_error_msg = '';
          this.submitted = false;
          // this.loginPage.emit();
          this.passConfirmationForm.markAsUntouched()
          this.passConfirmationForm.reset();
          if (this.is_from_verify_account) {
            setTimeout(() => {
              this.authService.setLoginResponseData({...this.login_response, ...credentials});
              this.loginPage.emit();
              this.is_passSucUpdated = true;
            }, 600);
          } else {
            this.is_passSucUpdated = true;
          };
        } else if(this.pass_update_response.code == '0') {
          this.update_pass_error_msg = this.pass_update_response.message;
          this.is_passSucUpdated = false;
        } else {
          this.update_pass_error_msg = `Error! Please try again or contact <a href="mailto:support@truein.com">support@truein.com<a> for help.`;
          this.is_passSucUpdated = false;
        };
        this.is_passUpdating = false;

      })
    }
  }

  validateOTP(e): boolean {
    const charCode = e.which ? e.which : e.keyCode;
    if ((charCode < 48 || charCode > 57) || e.target.value.length > 5) {
      return false
    }
    return true
  }

  getLoginPageTab() {
    this.loginPage.emit();
    this.location.replaceState('/login');
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
